"use client";
import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"

const Toaster = ({ ...props }) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="bottom-center"
      expand
      visibleToasts={9}
      style={{
        '--offset': '120px',
        bottom: '120px',
      }}
      toastOptions={{
        style: {
          marginBottom: '0px',
        },
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg z-[99999] px-4 py-3 rounded-lg",
          description: "group-[.toast]:text-black",
          title: "text-black",
          icon: "text-black",
          success: "!bg-white !text-black !border-black",
          error: "!bg-white !text-black !border-black",
          warning: "!bg-white !text-black !border-black",
          info: "!bg-white !text-black !border-black",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
        duration: 5000,
      }}
      {...props}
    />
  )
}

export { Toaster }